import { TableOutlined } from "@ant-design/icons";
import { Col, Row, Space, Table, Tooltip, Typography } from "antd";
import { showError } from "common/ToastNotifications";
import { LoadingOverlay } from "components";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";

const { Link, Text } = Typography;
const { Column } = Table;

class SystemConnectionHubspotObjects extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetchingObjects: false,
        };
    }

    componentWillMount() {
        this.setState({ fetchingObjects: true });
        this.props.getHubspotObjects(this.props.connectionId);
    }

    componentDidUpdate(prevProps) {
        if (this.props.getHubspotObjectsResult && this.props.getHubspotObjectsResult !== prevProps.getHubspotObjectsResult) {
            if (!this.props.getHubspotObjectsResult.success) {
                showError("Could not get HubSpot objects at this moment.");
            }
            this.setState({ fetchingObjects: false });
        }
    }

    handleObjectClick = (objectName) => {
        if (!objectName) return;
        this.props.onObjectSelected(objectName);
    };

    render() {
        const objects = (this.props.hubspotObjects || []).filter(obj => obj.queryable);

        return (
            <Row style={{ flexDirection: "column", flexGrow: 1, height: "100%" }}>
                <Col span={24} style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                    <LoadingOverlay busy={this.state.fetchingObjects} spinner message={"Fetching HubSpot objects..."}></LoadingOverlay>
                    <Table
                        size="small"
                        rowKey="name"
                        dataSource={objects}
                        pagination={false}
                        scroll={{ y: "100vh" }}
                        className="container-height-100"
                    >
                        <Column
                            dataIndex="label"
                            title="Object Label"
                            render={(value, record) => {
                                return (
                                    <Tooltip placement="topLeft" title={record.name}>
                                        <Space>
                                            <TableOutlined />
                                            <Link onClick={() => this.handleObjectClick(record.name)}>
                                                {value}
                                            </Link>
                                        </Space>
                                    </Tooltip>
                                );
                            }}
                        />
                        <Column
                            dataIndex="name"
                            title="API Name"
                            render={(value) => <Text>{value}</Text>}
                        />
                    </Table>
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        getHubspotObjectsResult: state.systemConnectionHubspot.getHubspotObjectsResult,
        hubspotObjects: state.systemConnectionHubspot.hubspotObjects,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getHubspotObjects: (connectionId) => dispatch(actions.getHubspotObjectsRequest(connectionId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SystemConnectionHubspotObjects));
